var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { updateDataFromCollection } from './utils';
const initialState = {
    loading: true,
    data: [],
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchAllDashboardWidgets = createAsyncThunk('dashboardWidgets/fetchAll', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboardWidgets.fetchAll();
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const createDashboardWidget = createAsyncThunk('dashboardWidgets/create', (dashboardWidget_1, _a) => __awaiter(void 0, [dashboardWidget_1, _a], void 0, function* (dashboardWidget, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboardWidgets.create(dashboardWidget);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateDashboardWidget = createAsyncThunk('dashboardWidget/update', (updatedWidget_1, _a) => __awaiter(void 0, [updatedWidget_1, _a], void 0, function* (updatedWidget, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboardWidgets.update(updatedWidget);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateDashboardWidgets = createAsyncThunk('dashboardWidgets/update', (data_1, _a) => __awaiter(void 0, [data_1, _a], void 0, function* (data, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.dashboardWidgets.collection.update(data);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteDashboardWidget = createAsyncThunk('widgets/delete', (dashboardWidgetId_1, _a) => __awaiter(void 0, [dashboardWidgetId_1, _a], void 0, function* (dashboardWidgetId, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.dashboardWidgets.delete(dashboardWidgetId);
        return fulfillWithValue(dashboardWidgetId);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { actions, reducer } = createSlice({
    name: 'dashboardWidgets',
    initialState,
    reducers: {
        setAllDashboardWidgets: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // CREATE DASHBOARD WIDGET
        builder.addCase(createDashboardWidget.pending, (state, { payload }) => { });
        builder.addCase(createDashboardWidget.fulfilled, (state, { payload }) => {
            const newData = [...state.data, payload];
            state.data = newData;
        });
        builder.addCase(createDashboardWidget.rejected, (state, { payload }) => { });
        // UPDATE DASHBOARD WIDGET
        builder.addCase(updateDashboardWidget.pending, (state, { payload }) => { });
        builder.addCase(updateDashboardWidget.fulfilled, (state, { payload }) => {
            const newData = state.data.map((dw) => {
                if (dw.id === payload.id) {
                    return payload;
                }
                return dw;
            });
            state.data = newData;
        });
        builder.addCase(updateDashboardWidget.rejected, (state, { payload }) => { });
        // UPDATE DASHBOARD WIDGETS
        builder.addCase(updateDashboardWidgets.pending, (state, { payload }) => { });
        builder.addCase(updateDashboardWidgets.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
        });
        builder.addCase(updateDashboardWidgets.rejected, (state, { payload }) => { });
        // DELETE DASHBOARD WIDGET
        builder.addCase(deleteDashboardWidget.pending, (state, { payload }) => { });
        builder.addCase(deleteDashboardWidget.fulfilled, (state, { payload }) => {
            state.data = state.data.filter((dw) => dw.id !== payload);
        });
        builder.addCase(deleteDashboardWidget.rejected, (state, { payload }) => { });
    },
});
export const { setAllDashboardWidgets } = actions;
export default reducer;
